import {
  Grid,
  Link,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { Container } from '@mui/system';
import React, { useEffect, useState } from 'react';
import { fetchGet } from '../../api/common';
import { StyledPaperItem } from '../../common/mui-components';

type QuestionScoreAverageDifference = {
  questionId: string;
  averageDifference: number;
  seenCount: number;
};

type Question = {
  alternateAnswers: string[];
  answer: string;
  category: string;
  difficulty: number;
  id: string;
  par: number;
  question: string;
};

export const Stats = () => {
  const [
    questionsScoreAverageDifferences,
    setQuestionsScoreAverageDifferences,
  ] = useState<QuestionScoreAverageDifference[]>();
  const [question, setQuestion] = useState<Question>();

  useEffect(() => {
    const fetchQuestionsScoreCounts = async () => {
      const qStatRes: QuestionScoreAverageDifference[] = await fetchGet(
        '/stats/questions-score-counts'
      );
      setQuestionsScoreAverageDifferences(
        qStatRes.sort((a, b) => b.averageDifference - a.averageDifference)
      );
    };
    fetchQuestionsScoreCounts();
  }, []);

  const handleQuestionIdClick = async (questionId: string) => {
    const res = await fetchGet(`/stats/question/${questionId}`);
    if (res) setQuestion(res);
  };

  return (
    <Container>
      <Grid container spacing={2}>
        <Grid item xs={5}>
          <StyledPaperItem>
            <Typography
              id="modal-modal-title"
              variant="h5"
              component="h2"
              mb={2}
              textAlign="center"
            >
              Player Score vs Par
            </Typography>
            <TableContainer component={Paper} sx={{ maxHeight: 300 }}>
              <Table stickyHeader size="small" aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    <TableCell>QuestionId</TableCell>
                    <TableCell>Avg. Diff.</TableCell>
                    <TableCell>Seen Count.</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {questionsScoreAverageDifferences?.map((row) => (
                    <TableRow key={row.questionId}>
                      <TableCell>
                        <Link
                          sx={{ cursor: 'pointer' }}
                          onClick={() => handleQuestionIdClick(row.questionId)}
                        >
                          {row.questionId}
                        </Link>
                      </TableCell>
                      <TableCell>{row.averageDifference}</TableCell>
                      <TableCell>{row.seenCount}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </StyledPaperItem>
        </Grid>
        <Grid item xs={7}>
          <StyledPaperItem>
            <Typography
              id="modal-modal-title"
              variant="h5"
              component="h2"
              mb={2}
              textAlign="center"
            >
              QuestionId: {question?.id || '[none]'}
            </Typography>
            <TableContainer component={Paper} sx={{ maxHeight: 300 }}>
              <Table stickyHeader size="small" aria-label="sticky table">
                <TableRow>
                  <TableCell width={'15%'}>Question:</TableCell>
                  <TableCell>{question?.question}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell width={'15%'}>Answer:</TableCell>
                  <TableCell
                    sx={{
                      textAlign: 'right',
                    }}
                  >
                    {question?.answer}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell width={'15%'}>Par:</TableCell>
                  <TableCell
                    sx={{
                      textAlign: 'right',
                    }}
                  >
                    {question?.par}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell width={'15%'}>Category:</TableCell>
                  <TableCell
                    sx={{
                      textAlign: 'right',
                    }}
                  >
                    {question?.category}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell width={'15%'}>Difficulty:</TableCell>
                  <TableCell
                    sx={{
                      textAlign: 'right',
                    }}
                  >
                    {question?.difficulty}
                  </TableCell>
                </TableRow>
              </Table>
            </TableContainer>
          </StyledPaperItem>
        </Grid>
      </Grid>
    </Container>
  );
};
